// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__OZcsv","modalForm":"UpgradeEpcsModal_modalForm__1ekez","modalFooter":"UpgradeEpcsModal_modalFooter__2Gi6k"};